<script lang="ts">
    import type { Diligence } from '../Model/Diligence';
    import { diligencesService } from '../services';
    import { Link, navigate } from "svelte-navigator";
    import ParamName from '../components/ParamName.svelte';
    import { dateInputFormatter, dateTimeInputFormatter } from '../services/Functions';

    export let thirdId: string;

    let diligences: Diligence[];

    $: load(thirdId)

    async function load(thirdId){
                        
        diligences = await diligencesService.findDiligencesByThird(thirdId);

        diligences.sort((a,b) => {
            return a.diligenceNumber < b.diligenceNumber ? -1 : 1;
        })

    }

</script>

<style>

</style>

<div class="row">
  <div class="col-12 table-responsive">
    {#if diligences?.length}
        <table class="table">
            <thead>
                
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">Nº Diligencia</th>
                        <th scope="col">Tipo</th>
                        <th scope='col'>Fecha</th>
                    </tr>
        
            </thead>
            <tbody>
                {#each diligences as diligence, index }
                    <tr>
                        <th scope="row">{index + 1}</th>
                        <td>
                            <a href="/diligencias/{diligence.id}" target='_blank'>
                                {diligence.diligenceNumber}
                            </a>
                        </td>
                        <td>
                            <ParamName id={diligence.diligenceTypeId} />
                        </td>
                        <td>
                            <span class="pe-2">{dateInputFormatter(diligence.entryDate)}</span>
                            {dateTimeInputFormatter(diligence.entryDate)}
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    {:else}
        <div class="text-center pt-5">
            <hr>
            <h4>No hay Diligencias para mostrar</h4>
        </div>
    {/if}
  </div>
</div>
